module.exports = __webpack_public_path__ + "img/2025.e3de3478.svg";